/* ===== Demo intern: butoanele fără date apar oricum și explică ce se pune acolo ===== */
import { getCurrentSettings } from '../services/settings.js?v=82.86';

const has = (v) => String(v || '').trim().length > 0;

/** id buton → [titlu, explicație, „lipsesc datele?”] */
const SPOTS = {
  clientWifiFab: ['Wi-Fi', 'Aici clienții tăi văd numele rețelei Wi-Fi și parola. Le completezi din aplicație, în câteva secunde.',
    (s) => !(s.wifiEnabled === true && has(s.wifiSsid))],
  clientLocationHoursFab: ['Program', 'Aici se afișează programul locației tale. Poți pune o poză cu programul sau îl completezi manual.',
    (s) => !(s.locationHoursEnabled === true && has(s.locationHoursImageURL))],
  clientLocationMapFab: ['Locație', 'Aici pui linkul locației tale din Google Maps. Clienții primesc drumul până la tine dintr-un tap.',
    (s) => !(s.locationMapEnabled === true && has(s.locationMapUrl))],
  clientReservationFab: ['Rezervări', 'Aici pui numărul tău de telefon. Clienții te sună pentru rezervări sau comenzi dintr-un tap.',
    (s) => !(s.reservationEnabled === true && (has(s.reservationPhone) || has(s.reservationWhatsapp) || has(s.reservationLink)))],
  feedbackBtn: ['Recenzie Google', 'Aici pui linkul de recenzii Google. Clienții mulțumiți îți lasă o recenzie dintr-un tap.',
    (s) => !(s.feedbackEnabled === true && has(s.clientFeedbackUrl))],
  locationMenuBtn: ['Meniu', 'Aici apare meniul sau lista ta de prețuri și servicii. Pui poze sau un link.',
    (s) => !(has(s.menuUrl) || (Array.isArray(s.menuImages) && s.menuImages.length > 0))]
};

function isDemo(s) {
  return !!s && s.internalDemo === true;
}

/** Arată butoanele goale (doar la demo). Se cheamă după ce aplicația și-a setat vizibilitatea. */
export function applyDemoPlaceholders(settings = getCurrentSettings()) {
  if (!isDemo(settings)) return;
  for (const [id, [, , missing]] of Object.entries(SPOTS)) {
    const n = document.getElementById(id);
    if (!n || !missing(settings)) continue;
    n.style.display = id === 'feedbackBtn' ? 'flex' : 'inline-flex';
    n.dataset.sjDemoEmpty = '1';
  }
  bindOnce();
}

let bound = false;
function bindOnce() {
  if (bound) return;
  bound = true;
  // pe window, în faza de captură → înaintea oricărui alt handler (inclusiv data-action)
  const handler = (e) => {
    const s = getCurrentSettings();
    if (!isDemo(s)) return;
    const target = e.target && e.target.closest ? e.target.closest(Object.keys(SPOTS).map((id) => `#${id}`).join(',')) : null;
    if (!target) return;
    const spot = SPOTS[target.id];
    if (!spot || !spot[2](s)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    showInfo(spot[0], spot[1]);
  };
  window.addEventListener('click', handler, true);
  window.addEventListener('pointerup', (e) => {
    const t = e.target && e.target.closest ? e.target.closest(Object.keys(SPOTS).map((id) => `#${id}`).join(',')) : null;
    if (t && isDemo(getCurrentSettings()) && SPOTS[t.id] && SPOTS[t.id][2](getCurrentSettings())) e.stopImmediatePropagation();
  }, true);
}

function showInfo(title, text) {
  document.getElementById('sjDemoInfo')?.remove();
  const wrap = document.createElement('div');
  wrap.id = 'sjDemoInfo';
  wrap.className = 'sj-demo-info';
  wrap.setAttribute('role', 'dialog');
  wrap.setAttribute('aria-modal', 'true');
  const close = () => wrap.remove();
  const bg = document.createElement('div');
  bg.className = 'sj-demo-info__bg';
  bg.addEventListener('click', close);
  const card = document.createElement('div');
  card.className = 'sj-demo-info__card';
  const kicker = document.createElement('small');
  kicker.textContent = 'Exemplu demonstrativ';
  const h = document.createElement('b');
  h.textContent = title;
  const p = document.createElement('p');
  p.textContent = text;
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.textContent = 'Am înțeles';
  btn.addEventListener('click', close);
  card.append(kicker, h, p, btn);
  wrap.append(bg, card);
  document.body.appendChild(wrap);
  requestAnimationFrame(() => wrap.classList.add('is-open'));
}
